/** Conservative text quote folding. HTML is handled by the sandboxed viewer. */
export function splitMailQuote(body: string) {
  const match = /^(?:>.*|Am .+ schrieb .+:|On .+ wrote:|-----Original Message-----)/m.exec(body)
  if (!match || match.index === undefined) return { text: body, quote: '' }
  return { text: body.slice(0, match.index).trimEnd(), quote: body.slice(match.index) }
}
